import { Star } from "lucide-react";
import { BUSINESS } from "@/constants";
import { Reveal } from "@/components/Reveal";

const reviews = [
  {
    name: "Ayesha K.",
    text: "Best keratin treatment I've had in Bur Dubai. The staff are so gentle and the salon feels private and calm.",
    service: "Hair",
  },
  {
    name: "Fatima R.",
    text: "Beautiful henna work for my sister's wedding — everyone asked where we got it done. Highly recommended.",
    service: "Henna",
  },
  {
    name: "Priya S.",
    text: "Clean, welcoming ladies-only salon. My gel nails lasted weeks. Booking on WhatsApp was super easy.",
    service: "Nails",
  },
];

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="py-28 sm:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <Reveal className="flex flex-wrap items-end justify-between gap-8 mb-16">
          <div>
            <span className="text-xs font-semibold tracking-[0.3em] uppercase text-gold">
              Loved Locally
            </span>
            <h2 className="mt-5 font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-bone leading-[1.05]">
              Bur Dubai's
              <em className="text-gold-gradient italic"> quiet favourite.</em>
            </h2>
          </div>
          <div
            data-testid="google-rating-badge"
            className="flex items-center gap-4 border border-line rounded-sm px-6 py-5"
          >
            <span className="font-serif text-5xl font-light text-bone">
              {BUSINESS.rating}
            </span>
            <div>
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={14}
                    className={
                      i < 4
                        ? "fill-gold text-gold"
                        : "fill-gold/30 text-gold/30"
                    }
                  />
                ))}
              </div>
              <p className="mt-1.5 text-xs text-sand tracking-wide">
                {BUSINESS.reviewCount} reviews on Google
              </p>
            </div>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-5">
          {reviews.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.1}>
              <figure
                data-testid={`review-card-${i}`}
                className="h-full border border-line rounded-sm p-8 flex flex-col bg-surface/40 hover:border-gold/40 transition-colors duration-500"
              >
                <span className="font-serif text-6xl text-gold/40 leading-none">
                  "
                </span>
                <blockquote className="mt-2 text-bone/90 leading-relaxed flex-1">
                  {r.text}
                </blockquote>
                <figcaption className="mt-6 pt-5 border-t border-line flex items-center justify-between">
                  <span className="text-sm font-semibold text-bone">
                    {r.name}
                  </span>
                  <span className="text-[10px] tracking-[0.25em] uppercase text-gold">
                    {r.service}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
